import { hashHistory } from 'react-router'
import {
  MATERIAL_LIST,
  PAGE_NAME,
  PATH_EDIT_ZGT_PLAN,
  PATH_ZGT,
  PATH_ZGT_RECHARGE,
  PLAN_STATUS_OPEN,
  STAT
} from './constant'
import { Modal } from 'hljd'
import Api from '@api/zhiGuangTong'
import {
  BOTH_SHOW__ZHI_GUANG_TONG_AND_ZHI_TUI_BAO,
  MATERIAL_PATH,
  SHOW_ZHI_GUANG_TONG
} from '@constant'
import moment from 'moment'
import { STAT_HIT } from '@util'
import mainStore from '@components/Main/store'

export const goZgtNewPlan = () => {
  hashHistory.push(PATH_EDIT_ZGT_PLAN)
}

export const goZgt = () => {
  hashHistory.push(PATH_ZGT)
}

export const goZgtRechargeDetail = () => {
  hashHistory.push(PATH_ZGT_RECHARGE)
}

/**
 * 计划已暂停
 */
export const isPlanPaused = ({ status, last_stop_at }) => {
  // if (last_stop_at) {
  //   return true
  // }

  return status != PLAN_STATUS_OPEN
}

/**
 * 计划投放中（已开启）
 */
export const isPlanOpened = record => {
  return !isPlanPaused(record)
}

export const isOverEditNum = edit_num => {
  return edit_num >= 3
}

export const goAddNewPlan = async cb => {
  const { success, data } = await Api.canAddNewPlan()
  cb && cb()

  // type 1金额不足 2素材问题 3无激活中的智推宝
  if (success) {
    const { can_add_new_plan, msg, type } = data
    if (can_add_new_plan) {
      hashHistory.push(PATH_EDIT_ZGT_PLAN)
    } else {
      Modal.confirm({
        title: '新建失败',
        content: msg,
        okText: type == 1 ? '立即充值' : type == 2 ? '创意管理' : '确定',
        onOk: () => {
          if (type == 1) {
            STAT_HIT({
              page_name: PAGE_NAME,
              element_tag: STAT.PAY
            })
            hashHistory.push(PATH_ZGT_RECHARGE)
          } else if (type == 2) {
            hashHistory.push(MATERIAL_PATH)
          } else {
          }
        }
      })
    }
  }
}

export const notEditWarn = () => {
  Modal.info({
    title: '无法进行该操作',
    content:
      '智优投广告系统上线后，老的智广通广告计划将不支持编辑。2020年3月15日后将删除所有老的智广通广告计划，为避免影响广告投放效果，建议您尽快创建新的智优投广告计划。',
    okText: '知道了'
  })
}

export const getMaterialListByTypes = list => {
  list = list || []
  const items = []
  list.forEach(type => {
    const val = MATERIAL_LIST.find(i => i.entity_type == type)
    if (val) {
      items.push(val)
    }
  })
  return items
}

export const getMaterialByType = materialType => {
  return MATERIAL_LIST.find(item => item.id == materialType) || {}
}

export const getMaterialByEntityType = entity_type => {
  return MATERIAL_LIST.find(item => item.entity_type == entity_type) || {}
}

export const CHARACTER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'

export const getInitialTitle = () => {
  const time = moment().format('YYYYMMDD')
  const random = () => Math.floor(Math.random() * (35 - 0)) + 0

  return `智优投${time}${CHARACTER[random()]}${CHARACTER[random()]}${
    CHARACTER[random()]
  }`
}

export const canEditByActiveAd = (getFieldValue, is_active_ad, entity_type) => {
  const d = getFieldValue(`sub_plans[${entity_type}].is_active_ad`)
  return d == undefined ? Boolean(is_active_ad) : d
}

export const getMaterialTabList = displayTypes => {
  return getMaterialListByTypes(
    (displayTypes.tabs || []).map(item => item.entity_type)
  )
}

export const isShowZhiGuangTong = () => {
  const { cpm_type } = mainStore
  return (
    cpm_type == SHOW_ZHI_GUANG_TONG ||
    cpm_type == BOTH_SHOW__ZHI_GUANG_TONG_AND_ZHI_TUI_BAO
  )
}
